import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
// import required modules
import { Autoplay, FreeMode, Navigation, Thumbs } from "swiper/modules";
import { apiUrl, assetsUrl } from "../config/config";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import Overlay from "../components/Overlay";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";
import { Button, Modal } from "react-bootstrap";

// import nusrat1 from "../images/product/nusrat1.png";
// import nusrat2 from "../images/product/nusrat2.png";
// import nusrat3 from "../images/product/nusrat3.png";
import sanamimg from "../images/product/sanamimg.jpeg";

import logo from "../images/logo-header.png";

import Swal from "sweetalert2";

import  basking  from '../images/basking-shark-logo.png';

const ProductPage = () => {
  // const { state } = useLocation();
  const { slug } = useParams();
  // console.log('slug >>', slug);
  const swiperRef = useRef(null);
  const swiperRefmodal = useRef(null);
  const [showloding, setshowloding] = useState(false);
  const [showmodal, setshowmodal] = useState(false);

  const [quantity, setquantity] = useState(1);

  const [price, setprice] = useState(2499);
  const [total, settotal] = useState(0);
  const [showinfomodal, setshowinfomodal] = useState(false);
  
  const [bname, setbname] = useState("");
  const [bmobile, setbmobile] = useState("");
  const [bemail, setbemail] = useState("");
  const [bpincode, setbpincode] = useState("");
  const [baddress, setbaddress] = useState("");
  const [selectedstate, setselectedstate] = useState("");
  const [selectedcity, setselectedcity] = useState("");
  const [statesdata, setstatesdata] = useState([]);
  const [citiesdata, setcitiesdata] = useState([]);

  const [sname, setsname] = useState("");
  const [smobile, setsmobile] = useState("");
  const [semail, setsemail] = useState("");
  const [spincode, setspincode] = useState("");
  const [saddress, setsaddress] = useState("");
  const [selectedstate1, setselectedstate1] = useState("");
  const [selectedcity1, setselectedcity1] = useState("");

  

  const [issameasbilling, setissameasbilling] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const totalRef = useRef(0);
  totalRef.current = total;

  // console.log('offerdata >>>', offerdata);

  const goToSlide = (index) => {
    console.log("swiperRef.current >>", swiperRef.current.swiper);
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(index);
      // setshowmodal(true);
    }
  };

  const goToSlide1 = (index) => {
    setshowmodal(true);
    setTimeout(() => {
      console.log("index >>", index);
      console.log("swiperRefmodal.current >>", swiperRefmodal?.current?.swiper);
      if (swiperRefmodal.current && swiperRefmodal.current.swiper) {
        swiperRefmodal.current.swiper.slideTo(index);
        // setshowmodal(true);
      }
    }, [100]);
  };

  const handleproductaddbuynow = () => {
    var newquantity = quantity && quantity !== "0" ? quantity : 1;
    settotal(price * newquantity );
    setshowinfomodal(true);
  };

  const fetchcustomestates = async () => {
    var data = {
      countrycode: 101,
    };
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .post(apiUrl + "getallstates", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          if (res?.data?.data?.length > 0) {
            setstatesdata(res?.data?.data);
          } else {
            setstatesdata([]);
          }
        } else {
        }
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  const fetchcustomecities = async (id) => {
    var data = {
      statecode: id,
    };
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .post(apiUrl + "getallcities", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          if (res?.data?.data?.length > 0) {
            setcitiesdata(res?.data?.data);
          } else {
            setcitiesdata([]);
          }
        } else {
        }
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  const generateRandom22DigitNumber = (maxnum) => {
    let randomNumber = '';
    
    // Generate random digits until we reach 22 digits
    while (randomNumber.length < maxnum) {
        randomNumber += Math.floor(Math.random() * 10); // Random digit from 0 to 9
    }

    return randomNumber;
}

  const paymentsuccessfunction = async(amount, paymentid) => {
    var random22DigitNumber = generateRandom22DigitNumber(22);
    var random8DigitNumber = generateRandom22DigitNumber(8);
    var newquantity = quantity && quantity !== "0" ? quantity : 1;
    console.log('paymentsuccessfunction >>');
    var data = {
      name: 'SANAM TERI KASAM BLACK LP (PRE BOOK)',
      hsnnumber: '85238010',
      sku: '19802911231',
      unitprice: price,
      qty: newquantity,
      price: price,
      taxrate: 18,
      taxamount: amount * 0.18,
      totalamount: amount,
      shippingcharge: 0,
      billing_details: {
        bname: bname,
        bmobile: bmobile,
        bemail: bemail,
        bpincode: bpincode,
        baddress: baddress,
        selectedstate: selectedstate,
        selectedcity: selectedcity
      },
      shipping_details: {
        sname: issameasbilling ? bname: sname,
        smobile: issameasbilling ? bmobile : smobile,
        semail: issameasbilling ? bemail : semail,
        spincode: issameasbilling ? bpincode : spincode,
        saddress: issameasbilling ? baddress : saddress,
        selectedstate: issameasbilling ? selectedstate : selectedstate1,
        selectedcity: issameasbilling ? selectedcity : selectedcity1
      },
      invoice_number: random8DigitNumber+'-Blist',
      order_number: 'Blist-'+random22DigitNumber,
      user_name: bname,
      user_email: bemail,
      user_number: bmobile,
      paymentid: paymentid,
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .post(apiUrl + "createnewproductorder", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          Swal.fire({
            title: 'Ordered Successfully!',
            text: "We'll notify you once it's shipped",
            icon: 'success',
            customClass: {
              icon: 'custom-swal-icon'
            },
            width: '400px',
            confirmButtonText: 'Ok'
          });
          setTimeout(() => {
            window.location.reload()
          }, 5000);
          
        } else {
        }
      })
      .catch((err) => {
        alert(err.message);
      });
  }

  const handlecheckout = () => {
    if(bname && bmobile && bemail && bpincode && baddress && selectedstate && selectedcity) {
        if(issameasbilling) {

        } else {
            if(sname && smobile && semail && spincode && saddress && selectedstate1 && selectedcity1) {

            } else {
                alert('Fill all mandatory shipping fields');
                return;
            }
        }
    } else {
        alert('Fill all mandatory fields');
        return;
    }
    // console.log('Hello world');

    displayRazorpay(totalRef?.current)

    // displayRazorpay(1);
  }

  const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};

  const displayRazorpay = async (amount) => {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

    if (!res) {
        alert('Razorpay SDK failed to load. Are you online?');
        return;
    }

    const options = {
        key: 'rzp_live_DAyD5EuV7mxduw', // Enter the Key ID generated from the Dashboard
        amount: amount * 100,
        // amount: 1 * 100,
        currency: 'INR',
        name: 'Blisstainment',
        description: '',
        image: 'https://your-logo-url.com', // Optional
        handler: function (response) {
            // alert('Payment successful! >>>');
            // console.log('Payment successful! >>>', response);
            console.log(response.razorpay_payment_id);
            paymentsuccessfunction(amount, response.razorpay_payment_id);
        },
        prefill: {
            name: bname,
            email: bemail,
            contact: bmobile,
        },
        notes: {
            address: 'Your Company Address',
        },
        theme: {
            color: '#fff',
        },
        modal: {
          // Event handler when the user closes the payment modal
          ondismiss: function() {
              // console.log('Payment process cancelled by the user.');
              // Handle the cancellation
          }
      },
      payment_failed: function(response) {
        console.error(response.error);
        // Handle payment failure
    }

    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
    paymentObject.on('payment.failed', function(response) {
      // Handle payment failure
  });

  paymentObject.on('modal.close', function() {
      // Handle the cancellation
  });
};

  useEffect(() => {
    if (selectedstate) {
      // console.log('state1 >>', state1);
      fetchcustomecities(selectedstate);
    }
  }, [selectedstate]);

  useEffect(() => {
    fetchcustomestates();
  }, []);

  return (
    <>
      <nav
        className="navbar navbar-expand-lg desknavbar mobhide"
        style={{ height: 80 }}
      >
        <div className="container">
          <div
            className="main-header dflex space-between align-items"
            style={{ justifyContent: "center" }}
          >
            <div className="logo">
              <br />
              <div className="navbar-logo" to="home">
                <img src={logo} />
              </div>
              <br />
            </div>
          </div>
        </div>
      </nav>
      <div className="mobilenavbardiv deskhide">
        <div className="mobilenavbarrow">
          <div className="mobilemenulogodiv">
            <img src={logo} />
          </div>
          
        </div>
      </div>
      <div className="navbarheight deskhide" style={{padding: 0}} />
      <Overlay showloader={showloding} />
      {showloding ? (
        <div className="loaderscreenheight"></div>
      ) : (
        <>
          <section className="pd50 productpagepd50" style={{ paddingTop: 80 }}>
            <div className="container">
              <h2 className="detaipageheadig">
                Vinyl-Hindi SANAM TERI KASAM - BLACK LP (PRE BOOK)
              </h2>
              <div className="row">
                <div className="col-md-5">
                  {/* <img src="https://www.blisstainment.com/assets/products/RR75141%204092001%20-%20COLOURED%20LP%2001.jpg" className='img-responsive' /> */}

                  <Swiper
                    ref={swiperRef}
                    style={{
                      "--swiper-navigation-color": "#fff",
                      "--swiper-pagination-color": "#fff",
                    }}
                    spaceBetween={10}
                    freeMode={true}
                    watchSlidesProgress={true}
                    navigation={true}
                    // thumbs={{ swiper: thumbsSwiper }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper"
                  >
                    <SwiperSlide>
                      <img
                        src={sanamimg}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          goToSlide1(0);
                        }}
                      />
                    </SwiperSlide>
                    {/* <SwiperSlide>
                      <img
                        src={nusrat2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          goToSlide1(1);
                        }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        src={nusrat3}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          goToSlide1(2);
                        }}
                      />
                    </SwiperSlide> */}
                  </Swiper>
                  <br />

                  {/* tumbnails */}
                  <Swiper
                    //    onSwiper={setThumbsSwiper}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper2"
                  >
                    <SwiperSlide>
                      <img
                        src={sanamimg}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          goToSlide(0);
                        }}
                      />
                    </SwiperSlide>
                    {/* <SwiperSlide>
                      <img
                        src={nusrat2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          goToSlide(1);
                        }}
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        src={nusrat3}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          goToSlide(2);
                        }}
                      />
                    </SwiperSlide> */}
                  </Swiper>
                </div>

                <div className="col-md-7">
                  <div className="product-content">
                    <h3 className="text-black fontweight600">
                    HIMESH RESHAMIYA
                    </h3>
                    <h3 className="text-black fontweight600">
                    SANAM TERI KASAM BLACK LP (PRE BOOK)
                    </h3>

                    <div>
                      <span className="product-price-details">₹ 2499</span>{" "}
                    </div>

                    <div className="contentdetails mt-3 mb-3">
                      <p className="mb-3 productdescription">
                      DOUBLE FOLD JACKET, 180 GRAMS, 331/3 RPM<br /><br />
                      EXPECTED RELEASE DATE IS AROUND END OF MARCH 2025
                      </p>

                      <>
                        <label className="labeldetails">Quantity: </label>{" "}
                        <input
                          value={quantity}
                          onChange={(t) => {
                            setquantity(t.target.value);
                          }}
                          type="number"
                          defaultValue="1"
                          className="quantitynumber"
                          min="1"
                          max="10"
                        />
                      </>
                    </div>
                    <div className="dflex mt-5 dblock">
                      <button
                        className="buynow"
                        onClick={() => {
                          handleproductaddbuynow();
                        }}
                      >
                        Buy Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <hr /> */}

          <hr />

          <>
            <div className="container mb-5">
              <h2 className="mb-5 weight600">Track Listing</h2>
              <div className="row">
                <div className="col-md-6">
                  <div className="sidea">
                    <h3>SIDE A</h3>
                    <ol>
                      <li>Sanam Teri Kasam <br /><span>(Ankit Tiwari & Palak Muchhal)</span></li>
                      <li>Kheech Meri Photo <br /><span>(Neeti Mohan, Akasa Singh & Darshan Raval)</span></li>
                      <li>Bewajah <br /><span>(Himesh Reshammiya)</span></li>
                      <li>Haal-E-Dil<br /><span>(Sreerama Chandra)</span></li>
                    </ol>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="sidea">
                    <h3>SIDE B</h3>
                    <ol>
                      <li>Tera Chehra <br /><span>(Arijit Singh)</span></li>
                      <li>Haal-E-Dil<br /><span>(Neeti Mohan)</span></li>
                      <li>Ek number <br /><span>(Himesh Reshammiya & Neeti Mohan)</span></li>
                      <li>Main Teri Yaadon Mein <br /><span>(Arijit Singh)</span></li>
                      <li>Sanam Teri Kasam (Reprise) <br /><span>(Mohammed Irfan & Palak Muchhal)</span></li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </>

          <div className="container mb-5">
            <h2 className="mb-3 weight600" style={{ color: "#e6993d" }}>
              Product Details
            </h2>

            <ul className="productdetailslist">
              <li>
                <span>HSN Code : </span> <span> 85238010</span>
              </li>
              <li>
                <span>Seller SKU ID : </span> <span> 19802911231</span>
              </li>
              <li>
                <span>Publisher : </span> <span> Sony Music</span>
              </li>
              <li>
                <span>Edition : </span> <span> 2025 edition</span>
              </li>
              <li>
                <span>Composer : </span> <span>Himesh Reshamiya</span>
              </li>
              <li>
                <span>EAN : </span> <span> 198029112313</span>
              </li>
              <li>
                <span>Artist : </span> <span> Himesh Reshamiya</span>
              </li>
              <li>
                <span>Country of origin : </span> <span> India</span>
              </li>
              <li>
                <span>Record Label/Studio : </span> <span> Sony Music</span>
              </li>
              <li>
                <span>Format : </span> <span> Vinyl-Hindi</span>
              </li>
              <li>
                <span>Number of disc : </span> <span> 1</span>
              </li>
              <li>
                <span>Language : </span> <span> HINDI</span>{" "}
              </li>
            </ul>
          </div>
          <section className="bgclor">
            <div className="container">
              <h3 className="uppercase text-golden social-text text-center">
                STAY CONNECTED WITH US
              </h3>

              <ul className="dflex content-center middle-social">
                <li>
                  <Link
                    to="https://www.facebook.com/blisstainment/"
                    target="_blank"
                  >
                    <i className="fa fa-facebook new-fa"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://instagram.com/blisstainment1?utm_medium=copy_link"
                    target="_blank"
                  >
                    <i className="fa fa-instagram new-fa"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.linkedin.com/in/blisstainment-a1b403209/"
                    target="_blank"
                  >
                    <i className="fa fa-linkedin new-fa"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://twitter.com/Blisstainment_1"
                    target="_blank"
                  >
                    <i className="fa fa-twitter new-fa"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </section>

          <footer>
      <div className="container" style={{paddingBottom: 20}}> 
        <div className="dflex space-between ptb30">
            <img src={logo} className='footer-logo' alt="" />

            <img src={basking} className='footer-logo' alt="" />
        </div>
  
        

      <div className="dflex mainfooter productpagemainfooter">
        <div className='footer-link'>
            <p className='uppercase ff'>SALES OFFICE:<br /><span className="productpagemainfooter-span">
               GODOWN NO. 458, 
               JAI BHAWANI INDUSTRIAL ESTATE,
               NEAR ST. XAVIER’S SCHOOL GATE, NO 4, GHODBUNDER ROAD, 
               CHITALSAR VILLAGE, MANPADA
               THANE, 400 607, INDIA.
               </span>
            </p>
        </div>   

         

        <div className='footer-link'>
            <p className='uppercase ff'>
               REGISTERED OFFICE:<br /><span className="productpagemainfooter-span">
               B-06, SATYAVANDAN,<br />
               KOLSHET ROAD,<br />
               THANE, 400 607,<br />
               INDIA.</span>
            </p>
        </div>    
      </div>
      </div>  
    </footer> 

    <section style={{backgroundColor:'#808080cc', color:'#fff'}} className="productpagecopyrightdiv">
        <div className='container'>
         <div className="dflex content-center fs13">
            <p className='border-left pd ff'>All rights reserved by @blisstainment.com</p>
            <p className='border-left pd ff'><Link to={'/terms'} className='disclaimer_title'>Disclaimer</Link></p>
            <p className='pd ff'><Link to={'/terms'} className='disclaimer_title'>Privacy Policy</Link></p>
        </div>
        </div>
    </section>

          {/*Add modal */}
          <Modal
            show={showmodal}
            onHide={() => setshowmodal(false)}
            size="lg"
            className="custom-width-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ fontSize: 19 }}></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="product-details-swipper-modal">
                <Swiper
                  ref={swiperRefmodal}
                  style={{
                    "--swiper-navigation-color": "#fff",
                    "--swiper-pagination-color": "#fff",
                  }}
                  spaceBetween={10}
                  navigation={true}
                  // thumbs={{ swiper: thumbsSwiper }}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <img src={sanamimg} />
                  </SwiperSlide>
                  {/* <SwiperSlide>
                    <img src={nusrat2} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={nusrat3} />
                  </SwiperSlide> */}
                </Swiper>
              </div>
            </Modal.Body>
          </Modal>

          {/* Info Modal */}
          <Modal
            show={showinfomodal}
            onHide={() => setshowinfomodal(false)}
            size="lg"
            className="custom-width-modal productpage-mainmodal"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ fontSize: 19 }}>
                Fill Up Your Details
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="product-details-swipper-modal">
                <div className="productpage-modal-totalrow">
                  <p className="productpage-modal-totaltext">Total :</p>
                  <p className="productpage-modal-totalprice">
                    ₹ {totalRef?.current}
                  </p>
                </div>
                <div className="productpage-billing-headdiv">
                    <p>Billing address</p>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label for="name" className="productpage-label">
                      Name *
                    </label>
                    <input
                    value={bname}
                    onChange={(t) => {
                        setbname(t.target.value);
                    }}
                      type="text"
                      className="form-control productpage-input"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label for="name" className="productpage-label">
                      Mobile *
                    </label>
                    <input
                    value={bmobile}
                    onChange={(t) => {
                        setbmobile(t.target.value);
                    }}
                      type="number"
                      className="form-control productpage-input"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label for="name" className="productpage-label">
                      Email *
                    </label>
                    <input
                    value={bemail}
                    onChange={(t) => {
                        setbemail(t.target.value);
                    }}
                      type="text"
                      className="form-control productpage-input"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label for="name" className="productpage-label">
                      Pincode *
                    </label>
                    <input
                    value={bpincode}
                    onChange={(t) => {
                        setbpincode(t.target.value);
                    }}
                      type="number"
                      className="form-control productpage-input"
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="productpage-label">Address *</label>
                    <textarea
                    value={baddress}
                    onChange={(t) => {
                        setbaddress(t.target.value);
                    }}
                      class="form-control productpage-input"
                      style={{ minHeight: 80 }}
                    ></textarea>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="productpage-label">State *</label>
                    <select
                      className="form-control productpage-input"
                      value={selectedstate}
                      onChange={(t) => {
                        setselectedstate(t.target.value);
                      }}
                    >
                      <option value="" selected disabled>
                        Select State
                      </option>
                      {statesdata?.length > 0
                        ? statesdata?.map((item, index) => {
                            return (
                              <option key={index} value={item?.name}>
                                {item.name}
                              </option>
                            );
                          })
                        : null}
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="productpage-label">City *</label>
                    <select
                      className="form-control productpage-input"
                      value={selectedcity}
                      onChange={(t) => {
                        setselectedcity(t.target.value);
                      }}
                    >
                      <option value="" selected disabled>
                        Select City
                      </option>
                      {citiesdata?.length > 0
                        ? citiesdata?.map((item, index) => {
                            return (
                              <option key={index} value={item?.name}>
                                {item.name}
                              </option>
                            );
                          })
                        : null}
                    </select>
                  </div>
                </div>
                <br />
                <div className="productpage-billing-headdiv">
                    <p>Shipping address</p>
                    <div className="d-flex" style={{marginLeft: 'auto'}}>
                          <p className="sameasbillingtext">
                            Same as Billing Address
                          </p>
                          <input
                            type="checkbox"
                            checked={issameasbilling}
                            onChange={() => {
                              setissameasbilling(!issameasbilling);
                            }}
                            className="sameasbillingtext_checkbox productpage-checkbox"
                          />
                        </div>
                </div>
                {
                    !issameasbilling ?
                    <div className="row">
                  <div className="col-md-6 mb-3">
                    <label for="name" className="productpage-label">
                      Name *
                    </label>
                    <input
                    value={sname}
                    onChange={(t) => {
                        setsname(t.target.value);
                    }}
                      type="text"
                      className="form-control productpage-input"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label for="name" className="productpage-label">
                      Mobile *
                    </label>
                    <input
                    value={smobile}
                    onChange={(t) => {
                        setsmobile(t.target.value);
                    }}
                      type="number"
                      className="form-control productpage-input"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label for="name" className="productpage-label">
                      Email *
                    </label>
                    <input
                    value={semail}
                    onChange={(t) => {
                        setsemail(t.target.value);
                    }}
                      type="text"
                      className="form-control productpage-input"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label for="name" className="productpage-label">
                      Pincode *
                    </label>
                    <input
                    value={spincode}
                    onChange={(t) => {
                        setspincode(t.target.value);
                    }}
                      type="number"
                      className="form-control productpage-input"
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="productpage-label">Address *</label>
                    <textarea
                    value={saddress}
                    onChange={(t) => {
                        setsaddress(t.target.value);
                    }}
                      class="form-control productpage-input"
                      style={{ minHeight: 80 }}
                    ></textarea>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="productpage-label">State *</label>
                    <select
                      className="form-control productpage-input"
                      value={selectedstate1}
                      onChange={(t) => {
                        setselectedstate1(t.target.value);
                      }}
                    >
                      <option value="" selected disabled>
                        Select State
                      </option>
                      {statesdata?.length > 0
                        ? statesdata?.map((item, index) => {
                            return (
                              <option key={index} value={item?.name}>
                                {item.name}
                              </option>
                            );
                          })
                        : null}
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="productpage-label">City *</label>
                    <select
                      className="form-control productpage-input"
                      value={selectedcity1}
                      onChange={(t) => {
                        setselectedcity1(t.target.value);
                      }}
                    >
                      <option value="" selected disabled>
                        Select City
                      </option>
                      {citiesdata?.length > 0
                        ? citiesdata?.map((item, index) => {
                            return (
                              <option key={index} value={item?.name}>
                                {item.name}
                              </option>
                            );
                          })
                        : null}
                    </select>
                  </div>
                </div>
                    : null
                }
                <button
                className="btn btn-primary btn-lg btn-block mt-2 mb-2"
                id="checkoutButton"
                type="submit"
                style={{width: '100%'}}
                onClick={() => {handlecheckout()}}
              >
                Submit & Pay ₹ {totalRef?.current}
              </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default ProductPage;
